<template>
  <div>
    <div class="modal-overlay"></div>
    <div class="modal modal--welcomeback modal--zero-balance "
         id="login_sms">
      <div class="modal__content">
        <button class="btn modal-close"><i class="icon-close"></i></button>
        <div class="modal__header modal_ti_header">

        </div>
        <div class="modal__body">
          <img class="modal_icon_alert" src="static/images/mobile-icon.svg" />
          <p>
            {{ getTranslations.home_custom_modals_subscribe_game_sms_text1 }} <br><br>
            {{ getTranslations.home_custom_modals_subscribe_game_sms_text2 }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  // modal_resubscribe_sms.html.html
  name: 'subscribe-game-sms',
  created() {
    this.showModal();
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
      'getTranslationByOperator',
    ]),
  },
  methods: {
    showModal() {
      const vm = this;
      /* eslint-disable */
      this.$nextTick(() => {
        // vm for instance of vue, and in it, the this is for window so the next line is necessary
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(() => {
          vm.$emit('close');
          $('.modal, .modal-overlay').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/custom_modals/SubscribeGameSms.vue